

import {Component, Vue } from 'vue-property-decorator'
import user_module from "@/modules/user";
import Input from "@/components/input2/index.vue";
import {checkPasswordStrength} from '@/lib/checkPasswordStrength';
import Strengthmeter from '@/components/strengthmeter/index.vue';


type CheckPasswordsArgs = {
    newPassword: string, 
    repeatNewPassword: string, 
    oldPassword: string
}

@Component({
    components: {
        Input,
        Strengthmeter
    }
})
export default class Restore extends Vue {

    public error: string = '';
    public login: string = '';
    public oldPassword: string = '';
    public newPassword: string = '';
    public repeatNewPassword: string = '';

    get passwordStrength(){

        return checkPasswordStrength(this.newPassword);

    }

    get repeatPasswordStrength(){

        return checkPasswordStrength(this.repeatNewPassword);

    }

    get disabled(){

        return this.forget ? !this.login : !(this.newPassword && this.repeatNewPassword && this.passwordStrength && this.repeatPasswordStrength)
    }

    get forget(){

        return this.$route.query?.forget === 'true';
    }

    get urlEmail(){

        return this.$route.query?.login
    }

    get urlCode(){

        return this.$route.query?.code;
    }

    get urltoken(){

        return this.$route.query?.token;
    }

    setError() {
      this.error = 'Fill in this field please'
    }

    restore () {

        console.log('this.forget', this.forget);

        if (this.disabled){
            return;
        }

        if (this.urlEmail && this.urlCode){

            this.setNewPassword();

        } else {

            if (!this.forget){

                this.forgotPassword();

            } else {

                this.restorePassword();

            }

        }

    }

    async setNewPassword(){

        console.log('preupdate');

        const message: any = this.checkPasswords({
            newPassword: this.newPassword, 
            repeatNewPassword: this.repeatNewPassword,
            oldPassword: this.oldPassword
        });

        if (message === 'success'){

            try {

                const result = await user_module.SetNewPassword({
                    NewPassword: this.newPassword,
                    Code: this.urlCode,
                    Email: this.urlEmail
                })


                if (result === 'Success'){

                    this.$toasted.success('Password has been reset', {
                        duration: 4000
                    });

                    
                    this.$router.push('/login');

                }


            } catch(err){

                var errMessage = '';
                if (err === 'New password cannot repeat last 3 passwords'){
                    errMessage = 'New password cannot be the same as your old passwords';
                }

                this.$toasted.error('Error. ' + errMessage, {
                    duration: 4000
                });

            }

        } else {

            this.$toasted.error(message, {
                duration: 4000
            });
        }

    }

    checkPasswords(data: CheckPasswordsArgs){

        const {newPassword, repeatNewPassword, oldPassword} = data;

        if (newPassword !== repeatNewPassword){

            return 'Passwords do not match';


        } else if (newPassword.length < 8 || !/\d/.test(newPassword)){

            return  'Password must be minimum of 8 characters, with at least one number';

        } else if (newPassword === oldPassword){

            return 'New password must be different from old password';

        }

        return 'success'
        

    }

    async forgotPassword(){

        try{

            const result = await user_module.forgotPassword(this.login);
            console.log('result', result);

            this.$toasted.success(`We’ve emailed a verification code to you. Please check your inbox ${user_module.userInfo.Email || ''} and type it below.`, {
                duration: 15000
            });                 

        } catch(err){

            this.$toasted.error('Error. Something is not right. Please try again or contact with our support', {
                duration: 4000
            });

        }

    }

    async restorePassword(){

        try {

            const result = await user_module.RestorePassword(this.login);

            console.log('result', result);
            
            this.$toasted.success(`We've emailed the reset password link to you, please check your inbox and/or spam folders.`, {
                duration: 15000
            });

        } catch(err){

            this.$toasted.error(err, {
                duration: 4000
            });

        }

    }
}
